import { useState, useEffect } from 'react';
import { Partner } from '@/types/data';

interface UsePartnersReturn {
  partners: Partner[];
  loading: boolean;
  error: string | null;
}

export const usePartners = (): UsePartnersReturn => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch('/api/partners');
        const data = await response.json();

        if (data.success) {
          setPartners(data.data);
        } else {
          setError(data.error || 'Failed to fetch partners');
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch partners');
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  return { partners, loading, error };
};